import React from 'react'
import CurvedArrowLongSvg from './Svg/CurvedArrowLongSvg'
import { ArrowProps } from './BottomLeftArrow'
import { useMediaQuery, useTheme } from '@mui/material'
import { GUI_LIVE_VIEW_BREAKPOINT_360, GUI_LIVE_VIEW_BREAKPOINT_XS, GUI_LIVE_VIEW_BREAKPOINT_XXS } from 'src/Libs/live-view/utils/breakpoints'
import CurvedArrowXxsSvg from './Svg/CurvedArrowXxsSvg'
import CurvedArrowXsSvg from './Svg/CurvedArrowXsSvg'

const BottomRightArrow: React.FC<ArrowProps> = ({ direction, sx }) => {
  const transform = 'scale(1)'
  const theme = useTheme()
  const isUpXxs = useMediaQuery(theme.breakpoints.up(GUI_LIVE_VIEW_BREAKPOINT_XXS))
  const isUpXs = useMediaQuery(theme.breakpoints.up(GUI_LIVE_VIEW_BREAKPOINT_XS))
  const isBetween360AndXs = useMediaQuery(theme.breakpoints.between(GUI_LIVE_VIEW_BREAKPOINT_360, GUI_LIVE_VIEW_BREAKPOINT_XS))

  if (isUpXs) {
    return <CurvedArrowLongSvg transform={transform} direction={direction} sx={sx} doRotateBy180Deg />
  }

  if (isBetween360AndXs) {
    return <CurvedArrowXsSvg transform={transform} direction={direction} sx={sx} doRotateBy180Deg />
  }

  if (isUpXxs) {
    return <CurvedArrowXsSvg transform={transform} direction={direction} sx={sx} doRotateBy180Deg />
  }

  return <CurvedArrowXxsSvg transform={transform} direction={direction} sx={sx} doRotateBy180Deg />
}

export default BottomRightArrow
